'use client'
import React from 'react';
import styled from "styled-components";
import {Col, Container, Row} from "react-bootstrap";
import { hover} from "@/styles/globalStyleVars";
import {Img} from "@/components/Img";


const MyComponent = ({data}) => {

    return (
        <StyledComponent className={'mission-vision pt-100 pb-100'} id={'mission'}>
            <Container>
                <Row className={'mission-vision__row'}>
                    <Col md={7} >
                        <div className={'mission-vision__left'}>
                            {
                                data?.posts?.list && data?.posts?.list?.length >0 &&
                                data?.posts?.list.map((element,index) => {
                                    return (
                                        <div className="mission-vision__left__single" key={index}>
                                            <h5>{element?.data?.subtitle}</h5>
                                            <h4>{element?.data?.description}</h4>
                                        </div>
                                    )
                                })
                            }

                        </div>
                    </Col>
                    <Col md={{offset: 1, span: 4}}>
                        <div className={'mission-vision__right'}>
                            <Img src={data?.images?.list?.[0]?.cdn_path} />
                        </div>
                    </Col>

                </Row>
            </Container>

        </StyledComponent>
    );
};
const StyledComponent = styled.section`
  background-color: ${hover};
    will-change: transform;
    .mission-vision__left{
        &__single{
            padding: 0 0 30px 0;
            
            h5{
                font-size: 18px;
                line-height: 24px;
                font-weight: 500;
                color: white;
                margin-bottom: 15px;
                @media(min-width: 1920px){
                    font-size: 20px;
                    line-height: 28px;
                }
            }
            h4{
                font-size: 24px;
                line-height: 32px;
                font-weight: 400;
                color: white; 
                @media(min-width: 1920px){
                    font-size: 28px;
                    line-height: 32px;
                }
                @media(max-width: 768px){
                    font-size: 20px;
                    line-height: 28px;
                }
                
            }
            &:nth-child(1){
                border-bottom: 1px solid rgba(255,255,255,0.5);
                margin-bottom: 40px;
            }
        }
    }
    .mission-vision__right{
        position: relative;
        padding-top: calc(450 / 400 * 100%);
        img{
            border-radius: 10px;
        }
    }
    
    .col-md-7{
        display: flex;
        flex-direction: column;
        justify-content: center;
    }
    
    @media(max-width: 768px){
        .mission-vision__row{
            display: flex;
            flex-direction: column;
            .col-md-4,.col-md-7{
                flex: 0 0 100%;
                max-width: 100%;
            }
            .offset-md-1{
                margin-left: 0;
            }
            .mission-vision__right{
                padding-top: calc(360 / 345 * 100%);
            }
        }
    }
`
export default MyComponent;